<template>
  <div>
    <el-table :data="data" border height="100%" style="width: 100%">
      <el-table-column prop="task_id" label="任务号" width="80">
      </el-table-column>
      <el-table-column prop="start_time" label="执行时间">
      </el-table-column>
    </el-table>
    <Pagination totalCountOrURL="/terminal/cnt_periodTaskExcuteRd" :params="{device_lgid:deviceId,task_id:periodTaskId}"
      @change="handlePageChange"></Pagination>
  </div>
</template>

<script>
  import Pagination from "@/components/PageNations/Pagination";
  export default {
    props: ["periodTaskId", "deviceId"],
    components: {
      Pagination
    },
    mounted() {
      this.getData();
    },
    watch: {
      periodTaskId() {
        this.getData();
      },
      deviceId() {
        this.getData();
      }
    },
    data() {
      return {
        data: [],
        page: 1,
        size: 10
      };
    },
    methods: {
      handlePageChange(params) {
        this.page = params.page;
        this.size = params.size;
        this.getData();
      },
      getData() {
        if (this.periodTaskId && this.deviceId) {
          this.$getJSON("/terminal/s_periodTaskExcuteRd", {
            device_lgid: this.deviceId,
            task_id: this.periodTaskId,
            page: this.page,
            size: this.size
          }).then(res => {
            this.data = res.data;
          });
        }
      }
    }
  };

</script>

<style scoped>


</style>



// WEBPACK FOOTER //
// src/components/Tables/PeriodTaskExcutionHistory.vue